import React from "react";
import { Box, Typography } from "@mui/material";
import { ArrowRight } from "lucide-react";

/**
 * Shared candidate-dashboard empty state.
 * Icon box + title + hint + optional CTA, styled to match the dashboard tokens.
 * Centered and fluid so it renders cleanly inside the mobile dashboard too.
 */
const EmptyState = ({ icon: Icon, title, subtitle, ctaLabel, onCta, py = "24px", card = false }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "10px",
      px: "16px",
      py,
      ...(card && {
        bgcolor: "hsl(0, 0%, 100%)",
        borderRadius: "16px",
        border: "1px solid hsla(160, 10%, 90%, 0.6)",
      }),
    }}
  >
    {Icon && (
      <Box
        sx={{
          width: "40px",
          height: "40px",
          borderRadius: "12px",
          bgcolor: "hsla(153, 68%, 25%, 0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon size={20} color="hsl(178, 10%, 45%)" />
      </Box>
    )}

    {title && (
      <Typography
        sx={{
          fontSize: "14px",
          fontFamily: "Segoe UI Bold, sans-serif, system-ui",
          color: "hsl(178, 10%, 45%)",
          textWrap: "balance",
        }}
      >
        {title}
      </Typography>
    )}

    {subtitle && (
      <Typography
        sx={{
          fontSize: "12px",
          color: "hsl(178, 10%, 45%)",
          fontFamily: "Segoe UI Regular, sans-serif, system-ui",
          lineHeight: 1.6,
          maxWidth: "260px",
        }}
      >
        {subtitle}
      </Typography>
    )}

    {ctaLabel && onCta && (
      <Box
        component="button"
        onClick={onCta}
        sx={{
          mt: "4px",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          fontSize: "12px",
          fontFamily: "Segoe UI Bold, sans-serif, system-ui",
          color: "hsl(153, 68%, 25%)",
          border: "none",
          bgcolor: "transparent",
          cursor: "pointer",
          transition: "opacity 0.15s",
          "&:hover": { opacity: 0.8 },
        }}
      >
        {ctaLabel} <ArrowRight size={12} />
      </Box>
    )}
  </Box>
);

export default EmptyState;
